import React from 'react';
import { Link } from 'react-router-dom';
import { MapPin, Phone, Mail, Clock } from 'lucide-react';

const Footer = () => {
  return (
    <footer className="bg-gray-900 text-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-10 sm:py-12">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-8">
          {/* Company Info */}
          <div className="space-y-4 sm:space-y-6">
            <div className="flex items-center space-x-3">
              <div className="text-xl font-bold text-red-500">
                Texas Tint Studio
              </div>
            </div>
            <p className="text-gray-300 leading-relaxed text-sm sm:text-base">
              Professional window tinting services for automotive, residential, and commercial properties in Missouri City, Texas.
            </p>
          </div>

          {/* Quick Links */}
          <div className="space-y-4 sm:space-y-6">
            <h3 className="text-lg font-semibold text-white">Quick Links</h3>
            <div className="grid grid-cols-2 gap-2">
              <Link to="/" className="text-gray-300 hover:text-red-500 transition-colors text-sm sm:text-base">Home</Link>
              <Link to="/services" className="text-gray-300 hover:text-red-500 transition-colors text-sm sm:text-base">Services</Link>
              <Link to="/book" className="text-gray-300 hover:text-red-500 transition-colors text-sm sm:text-base">Book Now</Link>
              <Link to="/reviews" className="text-gray-300 hover:text-red-500 transition-colors text-sm sm:text-base">Reviews</Link>
              <Link to="/contact" className="text-gray-300 hover:text-red-500 transition-colors text-sm sm:text-base">Contact</Link>
            </div>
          </div>

          {/* Contact Info */}
          <div className="space-y-4 sm:space-y-6">
            <h3 className="text-lg font-semibold text-white">Contact Info</h3>
            <div className="space-y-3 sm:space-y-4">
              <div className="flex items-start space-x-3">
                <MapPin className="h-5 w-5 text-red-500 mt-0.5 flex-shrink-0" />
                <div className="text-gray-300 text-sm sm:text-base">
                  <p>6951 McHard Road, Suite G8</p>
                  <p>Missouri City, TX 77053</p>
                </div>
              </div>
              <div className="flex items-center space-x-3">
                <Phone className="h-5 w-5 text-red-500 flex-shrink-0" />
                <a href="tel:(713)446-8928" className="text-gray-300 hover:text-red-500 transition-colors text-sm sm:text-base">(713) 446-8928</a>
              </div>
              <div className="flex items-center space-x-3">
                <Mail className="h-5 w-5 text-red-500 flex-shrink-0" />
                <a href="mailto:info@texastintstudio.com" className="text-gray-300 hover:text-red-500 transition-colors text-sm sm:text-base break-all">info@texastintstudio.com</a>
              </div>
              <div className="flex items-start space-x-3">
                <Clock className="h-5 w-5 text-red-500 mt-0.5 flex-shrink-0" />
                <div className="text-gray-300 text-sm sm:text-base">
                  <p>Mon - Fri: 9AM - 6PM</p>
                  <p>Sat: 9AM - 5PM | Sun: Closed</p>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div className="mt-8 sm:mt-12 pt-6 sm:pt-8 border-t border-gray-800 text-center">
          <p className="text-gray-400 text-sm">
            &copy; {new Date().getFullYear()} Texas Tint Studio. All rights reserved.
          </p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
